import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewEncapsulation,
  booleanAttribute,
  computed,
  input,
  model,
  output,
  viewChild,
} from '@angular/core';
import { MatAutocomplete, MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { getUUID } from '@dmb/core';

import { InlineSpinnerComponent } from '../../inline-spinner/inline-spinner.component';
import { HelpButtonComponent } from '../help-button/help-button.component';

@Component({
  selector: 'dmb-base-input',
  templateUrl: './base-input.component.html',
  styleUrls: ['./base-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HelpButtonComponent,
    InlineSpinnerComponent,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
  ],
})
export class BaseInputComponent {
  value = model.required<string>();
  errors = input<string[] | undefined | null>();
  warnings = input<string[] | undefined | null>();
  pending = input(false);

  type = input('text');
  placeholder = input<string | null>(null);
  label = input<string>();
  required = input(false, { transform: booleanAttribute });
  autoComplete = input<MatAutocomplete>();
  helpText = input<string>();
  blurred = output<FocusEvent>();
  name = input<string | null>(null);
  readOnly = input(false, { transform: booleanAttribute });
  disabled = input(false, { transform: booleanAttribute });
  min = input<string | number | null>(null);
  max = input<string | number | null>(null);
  step = input<string>();

  hasError = computed(() => {
    const errs = this.errors();
    return Array.isArray(errs) && errs.length > 0;
  });

  elementRef = viewChild<ElementRef<HTMLInputElement>>('theInput');
  autocompleteTriggerRef = viewChild(MatAutocompleteTrigger);

  id = getUUID();
}
